import { createSlice } from '@reduxjs/toolkit';
import { Coordinate } from 'types/map';

const initialValue: { editing: boolean; coords?: Coordinate[] } = {
  editing: false,
  coords: null,
};

export const editSlice = createSlice({
  name: 'edit',
  initialState: {
    value: initialValue,
  },
  reducers: {
    initEdit: (state) => {
      state.value.editing = true;
    },
    stopEdit: (state) => {
      state.value.editing = false;
      state.value.coords = null;
    },
    addCoords: (state, action: { payload: { coords: Coordinate[] } }) => {
      if (state.value.editing) {
        state.value.coords = action.payload.coords;
      } else {
        console.log('Not editing, coordinates discarded');
      }
    },
    removeCoords: (state) => {
      state.value.coords = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { initEdit, addCoords, removeCoords, stopEdit } =
  editSlice.actions;
export const selectAllRoutes = (state) => state.routes;

export default editSlice.reducer;
